import Qrpage from './Qrpage';

const ACTION = {
  ...Qrpage.ACTION,
};

const ACTION_TYPES = {
  ...Qrpage.ACTION_TYPES,
};

const qrcode = {
  ACTION,
  ACTION_TYPES
}

export default qrcode;